<template>
  <div v-if="visible" class="black-friday-banner-overlay" @click.self="close">
    <div class="black-friday-banner">
      <button @click="close" class="close-button">×</button>
      <a :href="linkUrl" @click="handleClick">
        <img
          v-if="!isMobile"
          :src="desktopImage"
          alt="Black Friday - Mega Oferta Touros P.O."
          class="banner-image desktop"
        />
        <img
          v-else
          :src="mobileImage"
          alt="Black Friday - Mega Oferta Touros P.O."
          class="banner-image mobile"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { setCookie, checkCookie } from "utils/cookies";

export default {
  props: {
    desktopImage: {
      type: String,
      required: true,
    },
    mobileImage: {
      type: String,
      required: true,
    },
    linkUrl: {
      type: String,
      required: true,
    },
    cookieDuration: {
      type: Number,
      default: 6 * 60 * 60,
    },
  },
  setup(props) {
    const visible = ref(false);
    const isMobile = computed(() => window.innerWidth <= 768);

    onMounted(() => {
      visible.value = !checkCookie("black_friday_banner_closed");

      if (visible.value) {
        mixpanel.track("Black Friday Banner - Pageview", {
          "Link URL": props.linkUrl,
          "Page Title": document.title,
        });
      }
    });

    const close = () => {
      setCookie("black_friday_banner_closed", true, props.cookieDuration);
      visible.value = false;

      mixpanel.track("Black Friday Banner - Closed", {
        "Link URL": props.linkUrl,
        "Page Title": document.title,
      });
    };

    const handleClick = () => {
      setCookie("black_friday_banner_closed", true, props.cookieDuration);

      mixpanel.track("Black Friday Banner - Clicked", {
        "Link URL": props.linkUrl,
        "Page Title": document.title,
      });
    };

    return {
      visible,
      isMobile,
      close,
      handleClick,
    };
  },
};
</script>
